import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api";

export default function PromoterDashboard() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [payouts, setPayouts] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/me/summary"), api.get("/me/payouts")])
      .then(([summary, history]) => { setData(summary.data); setPayouts(history.data); })
      .catch(() => setData({}));
  }, []);

  const copyLink = async () => {
    try { await navigator.clipboard.writeText(data.referralUrl); } catch (_) {}
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  if (!data) return <div className="loading">Loading…</div>;

  return (
    <div data-testid="promoter-dashboard-page">
      <header className="page-head">
        <h1>My Dashboard</h1>
        <Link to="/portal/commissions" className="btn btn-ghost" data-testid="go-commissions">View commissions →</Link>
      </header>

      <div className="detail-grid">
        <div><span className="muted">Name</span><div data-testid="promoter-name">{data.name || "—"}</div></div>
        <div><span className="muted">Referral Code</span><div><code data-testid="promoter-code">{data.code || "—"}</code></div></div>
        <div><span className="muted">Default Commission %</span><div data-testid="promoter-default-rate">{data.defaultRate ?? "—"}</div></div>
        <div>
          <span className="muted">Referral Link</span>
          <div className="link-cell">
            <span className="ref-url" data-testid="promoter-referral-url">{data.referralUrl || "—"}</span>
            {data.referralUrl && (
              <button className="btn btn-ghost btn-sm" data-testid="copy-referral" onClick={copyLink}>
                {copied ? "Copied!" : "Copy"}
              </button>
            )}
          </div>
        </div>
      </div>

      <h2 className="section-title">Commission Summary (by currency)</h2>
      {(data.summary || []).length === 0 ? (
        <div className="empty" data-testid="promoter-summary-empty">No commissions yet.</div>
      ) : (
        <div className="table-wrap">
          <table data-testid="promoter-summary-table">
            <thead><tr><th>Currency</th><th>Pending</th><th>Payable gross</th><th>Clawback</th><th>Currently owed</th><th>Paid</th><th>Lifetime</th></tr></thead>
            <tbody>
              {data.summary.map((s) => (
                <tr key={s.currency} data-testid={`summary-row-${s.currency}`}>
                  <td><code>{s.currency}</code></td>
                  <td data-testid={`pending-${s.currency}`}>{s.pending}</td>
                  <td data-testid={`payable-${s.currency}`}>{s.payableGross}</td>
                  <td data-testid={`clawback-${s.currency}`}>{s.outstandingClawback}</td>
                  <td data-testid={`owed-${s.currency}`}>{s.netCurrentlyOwed}</td>
                  <td data-testid={`paid-${s.currency}`}>{s.paid}</td>
                  <td data-testid={`lifetime-${s.currency}`}>{s.lifetime}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <h2 className="section-title">Payout History</h2>
      {payouts.length === 0 ? <div className="empty">No payouts yet.</div> : (
        <div className="table-wrap"><table data-testid="promoter-payout-history">
          <thead><tr><th>Paid</th><th>Currency</th><th>Gross</th><th>Clawbacks</th><th>Net paid</th><th>Commissions</th></tr></thead>
          <tbody>{payouts.map((p) => <tr key={p.id}>
            <td>{new Date(p.paidAt).toLocaleString()}</td><td>{p.currency}</td>
            <td>{p.grossCommissionAmount}</td><td>{p.adjustmentAmount}</td>
            <td>{p.netPaidAmount}</td><td>{p.commissionCount}</td>
          </tr>)}</tbody>
        </table></div>
      )}
    </div>
  );
}
